//
//
//
//

import dataLoggerAttributesQuery from '~/apollo/queries/product/data-logger-attributes'

export default {
  props: {
    productId: String
  },
  apollo: {
    dataLoggerAttributes: {
      prefetch: true,
      query: dataLoggerAttributesQuery,
      variables () {
        return { documentId: this.productId }
      }
    }
  }
}
